import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {

    obterPorIdContrato(contrato) {
        return axiosJwt.get(`${api}/aditivocontrato/obterporidcontrato/${contrato.idContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAditivoContrato(aditivoContrato) {
        return axiosJwt.post(`${api}/aditivocontrato`, aditivoContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    // obterProcessoGedocPorNumero(numeroprocesso) {
    //     return axiosJwt.get(`${api}/aditivocontrato/obterprocessogedocpornumero/${numeroprocesso}`)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterTiposAditivos() {
        return axiosJwt.get(`${api}/aditivocontrato/tiposaditivos?ativo=true`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },



}
